import React, { useState } from "react";
import ModalBaseView from "../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../common-deprecated/styles/v2/lexus/globals/Modal";
import Icon from "../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import { BnbLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as PackStyles from "../step-customize/main-content/styles/Pack";
import Extra from "../common/extras/Extra";
import type { BuildAndBuyDispatchType } from "../../../redux/store";
import { resolveExtraConflicts } from "../../../redux/actions/BasketActions";
import type { ExtraConflictModalType } from "../../../utils/modalConstants";
import ButtonPrimary from "../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import type { ModalViewType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const ExtraConflictModal = (props: ModalViewType<ExtraConflictModalType>): JSX.Element => {
    const { show, close, modalSettings } = props;
    const { extra, conflicts, extraPendingStack } = modalSettings;

    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const [selectedId, setSelectedId] = useState<string | null>(null);

    return (
        <ModalBaseView modalIdType={modalSettings.type} onClose={close} show={show} size="md">
            <Modal.Header>
                <Modal.Title>
                    <BnbLabel label="equipmentConflictTitle" />
                </Modal.Title>
                <Modal.Button onClick={close}>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                </Modal.Button>
            </Modal.Header>

            <Modal.Body>
                {conflicts && conflicts.length > 0 && (
                    <PackStyles.Grid>
                        {conflicts.map((item) => (
                            <Extra
                                key={item.id}
                                extra={item}
                                equipped={selectedId === item.id}
                                onSelect={() => {
                                    if (!selectedId || selectedId !== extra.id) setSelectedId(item.id);
                                    else setSelectedId(null);
                                }}
                                optional
                                enabled
                            />
                        ))}
                    </PackStyles.Grid>
                )}
            </Modal.Body>

            <Modal.Actions>
                <Flex.Col p={0} display="flex" justifyContent="flex-end">
                    <ButtonPrimary
                        disabled={!selectedId}
                        onClick={() => {
                            const selectedExtra = conflicts.find((conflictExtra) => selectedId === conflictExtra.id);
                            if (selectedExtra) {
                                dispatch(resolveExtraConflicts(extra, selectedExtra, true, extraPendingStack));
                                close();
                            }
                        }}
                    >
                        {/* Reusing the pack conflict label here */}
                        <BnbLabel label="packConflictContinue" />
                    </ButtonPrimary>
                </Flex.Col>
            </Modal.Actions>
        </ModalBaseView>
    );
};

export default ExtraConflictModal;
